@if (nav.showNav && notifications) {
  <nav class="navbar navbar-expand-md navbar-dark bg-dark-blue">
    <div id="brand">
      <a class="navbar-brand cursor-pointer" [routerLink]="['/admin']">
        <img src="/assets/img/logo-nav.png" [alt]="version" />
      </a>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      aria-controls="main-nav"
      aria-label="Toggle navigation"
      [attr.aria-expanded]="!isMenuCollapsed()"
      (click)="isMenuCollapsed.set(!isMenuCollapsed())">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse" id="main-nav" [ngbCollapse]="isMenuCollapsed()">
      <div class="d-md-flex w-100 justify-content-end">
        <!--Notification start-->
        @if (authService.loggedIn && notifications) {
          <div class="right-nav-wrap flex-shrink-1">
            <ul class="navbar-nav ml-auto">
              <li
                ngbDropdown
                placement="bottom-end top-end"
                class="nav-item dropdown text-nowrap upanel-dropdown-handler">
                <a
                  aria-haspopup="true"
                  ngbDropdownToggle
                  appKeyboardClickable
                  class="nav-link cursor-pointer no-caret"
                  id="upanel-dropdown-trigger"
                  role="button">
                  <span class="nav-user-wrap clearfix">
                    @if (isLoggedInUserImage) {
                      <span
                        class="avatar avatar-sm"
                        [ngStyle]="{ 'background-image': 'url(' + loggedInUserAvatarUrl + ')' }"></span>
                    }
                    @if (!isLoggedInUserImage) {
                      <span
                        class="avatar avatar-sm"
                        [ngStyle]="{
                          'background-color': 'gray',
                          width: '40px',
                          height: '40px',
                          'text-align': 'center',
                          'line-height': '40px',
                        }">
                        {{ loggedInUserFullName }}
                      </span>
                    }
                    <span class="nav-user-name-wrap d-none d-xl-inline-block">
                      <span class="nav-user-name">{{ loggedInUserEmail }}</span>
                      <span class="nav-user-company">{{ authService.companyName }}</span>
                    </span>
                    <i class="material-icons"> keyboard_arrow_down </i>
                  </span>
                </a>
                <div
                  ngbDropdownMenu
                  id="upanel-dropdown"
                  class="dropdown-menu dropdown-menu-right shadow"
                  aria-labelledby="upanel-dropdown-trigger">
                  <a ngbDropdownItem class="dropdown-item" href="#" (click)="logout($event)">
                    <i class="material-icons mi-inline mr-2">exit_to_app</i>{{ '$action_logout$' | translate }}
                  </a>
                  <hr />
                  <div>
                    @if (version !== apiVersion) {
                      {{ version }}/{{ apiVersion }}
                    } @else {
                      {{ version }}
                    }
                  </div>
                </div>
              </li>
            </ul>
          </div>
        }
        <!--Notification End-->
        @if (!authService.loggedIn) {
          <div class="right-nav-wrap flex-shrink-1" style="margin-right: -16px">
            <ul class="navbar-nav ml-auto">
              <li>
                <a (click)="authService.login()"
                  ><i class="material-icons mi-inline mr-2"></i>{{ '$action_login$' | translate }}</a
                >
              </li>
            </ul>
          </div>
        }
      </div>
    </div>
  </nav>
}
